import axios from 'axios';
import React, { useEffect, useState, useMemo } from 'react';
import html2pdf from 'html2pdf.js';
import '../component/assesment.css';
import Createperson from '../component/Createperson'
import { useNavigate } from 'react-router-dom';
import { Button, Modal,Table } from 'antd';
;
const Assesment = () => {
  const [sum, setSum] = useState(0);
  const [flag, setFlag] = useState(false);
  const [flag2, setFlag2] = useState(true);


  const [sessionvalue, setSessionvalue] = useState([]);
const navigate=useNavigate();

  const [formData, setFormData] = useState({
    painIntensity: "",
    personalCare: "",
    lifting: "",
    walking: "",
    sitting: "",
    standing: "",
    sleeping: "",
    socialLife: "",
    travelling: "",
    employment: ""
  });
  const dataSource = [
    { key: '1',
      Score : '0% to 20%: ',
  Description: 'minimal disability',
},
{ key: '2',
  Score : '21%-40%',
Description: `moderate disability` ,
},
{ key: '3',
  Score : '41%-60%',
Description: `severe disability` ,
},
{ key: '4',
  Score : '61%-80%',
Description: `crippled` ,
},
{ key: '5',
  Score : '81%-100%',
Description: `tough for life`,
},
];

const columns = [
{
  title: 'Score',
  dataIndex: 'Score',
  key: 'Score',
},

{
  title: 'Description',
  dataIndex: 'Description',
  key: 'Description',
},
];

const getRowClassName = (sum) => {
  const numericSum = parseFloat(sum.sum);
  console.log(numericSum)
  if (numericSum < 20) {
    return '#44ce1b'; // Light green for values less than 20
  } else if (numericSum >= 20 && numericSum <= 40) {
    console.log(30 )
    return '#bbdb44'; // Light blue for values between 20 and 40
  } 
  else if (numericSum>= 40 && numericSum<= 60) {
    return '#f7e379'; // Light blue for values between 20 and 40
  }
  else if (numericSum >= 60 && numericSum <= 80) {
    return '#f2a134'; // Light blue for values between 20 and 40
  }
  else {
    return '#e51f1f'; // Light yellow for values greater than 40
  }
};


  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
    
  };
  const handleOk = () => {
    
    setIsModalOpen(false);
    navigate('/login/home');
  };
  const handleCancel = () => {
  
    setIsModalOpen(false);
    navigate('/login/home');
  };
  const handleChange = (section, value) => {
    setFormData(prevState => ({
      ...prevState,
      [section]: value
    }));
  };

  useEffect(() => {
    const storedFormData = sessionStorage.getItem('formData');
    const finalsession = storedFormData ? JSON.parse(storedFormData) : {};
    setSessionvalue(finalsession);
  }, []);

  const handleSubmit = (e) => {
    console.log(dataSource[0].Description)
    showModal();
    setFlag(true);
    e.preventDefault();
    const totalSum = Object.values(formData).reduce((acc, value) => acc + Number(value), 0);

    setSum((totalSum/50)*100);


  };
  const uploadpdf = async () => {
    try {
      await axios.post('https://nsureback.asianspinehospital.com/score', { ...formData,  sessionvalue },sum);
      console.log("Data uploaded successfully");
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };
  const downloadPDF = () => {
    navigate('/login/home')
    setFlag(false);
   
    const element = document.getElementById('pdf-content');
    const opt = {
      marginTop: 100,
      marginBottom: 120,

      filename: `${sessionvalue.name}assessment.pdf'`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2},
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().from(element).set(opt).save();
    html2pdf().from(element).set(opt).outputPdf('blob').then(async (pdfBlob) => {
      const formData = new FormData();
      formData.append('pdf', pdfBlob,'assessment.pdf');
      formData.append('mobile', sessionvalue.mobile);
      formData.append('score',sum );

      console.log(formData+`this is form data`);
      try {
        // Send the blob to the backend
        await axios.post('https://nsureback.asianspinehospital.com/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log('PDF successfully uploaded');
      } catch (error) {
        console.error('Error uploading the PDF:', error);
      }
    });
  };

 
  const questions = useMemo(() => [
    {
      id: 'painIntensity',
      label: '1) Pain Intensity',
      options: [
        "I can tolerate the pain without having to use pain killers",
        "The pain is bad but I manage without taking pain killers",
        "Pain killers give complete relief from pain",
        "Pain killers give moderate relief from pain",
        "Pain killers give very little relief from pain",
        "Pain killers have no effect on the pain and I do not use them"
      ]
    },
    {
      id: 'personalCare',
      label: '2) Personal Care (e.g. Washing, Dressing)',
      options: [
        "I can look after myself normally without causing extra pain",
        "I can look after myself normally but it causes extra pain",
        "It is painful to look after myself and I am slow and careful",
        "I need some help but manage most of personal care",
        "I need help every day in most aspects of self-care",
        "I don't get dressed, I wash with difficulty and stay in bed"
      ]
    },
    {
      id: 'lifting',
      label: '3) Lifting',
      options: [
        "I can lift heavy weights without pain",
        "I can lift heavy weights but it gives extra pain",
        "Pain prevents me from lifting heavy weights off the floor but if they are conveniently positioned",
        "Pain prevents me from lifting heavy weights, but I can manage light to medium weights if conveniently positioned",
        "I can lift very light weights",
        "I cannot lift or carry anything at all"
      ]
    },
    {
      id: 'walking',
      label: '4) Walking',
      options: [
        "Pain does not prevent me walking any distance",
        "Pain prevents me walking more than one mile (1.6 kms)",
        "Pain prevents me walking more than half mile (0.8 kms)",
        "Pain prevents me walking more than quarter mile (0.4 kms)",
        "I can only walk using a stick or crutches",
        "I am in bed most of the time and have to crawl to the toilet"
      ]
    },
    {
      id: 'sitting',
      label: '5) Sitting',
      options: [
        "I can sit in any chair as long as I like",
        "I can sit in my favorite chair as long as I like",
        "Pain prevents me from sitting more than one hour",
        "Pain prevents me from sitting more than half an hour",
        "Pain prevents me from sitting more than 10 minutes",
        "Pain prevents me from sitting at all"
      ]
    },
    {
      id: 'standing',
      label: '6) Standing',
      options: [
        "I can stand as long as I want without getting extra pain",
        "I can stand as long as I want but it gives me extra pain",
        "Pain prevents me from standing for more than one hour",
        "Pain prevents me from standing more than half an hour",
        "Pain prevents me from standing more than 10 minutes",
        "Pain prevents me from standing at all"
      ]
    },
    {
      id: 'sleeping',
      label: '7) Sleeping',
      options: [
        "Pain does not prevent me from sleeping well",
        "I can sleep well only by using medication",
        "Even when I take medication, I have less than 6 hours sleep",
        "Even when I take medication, I have less than 4 hours sleep",
        "Even when I take medication, I have less than 2 hours sleep",
        "Pain prevents me from sleeping at all"
      ]
    },
    {
      id: 'socialLife',
      label: '8) Social Life',
      options: [
        "My social life is normal and gives me no extra pain",
        "My social life is normal but increases the degree of pain",
        "Pain has no significant effect on my life apart from limiting my more energetic interests (e.g. dancing)",
        "Pain has restricted my social life and I do not go out as often",
        "Pain has restricted my social life to my home",
        "I have no social life because of pain"
      ]
    },
    {
      id: 'travelling',
      label: '9) Travelling',
      options: [
        "I can travel anywhere without any pain",
        "I can travel anywhere but it gives me extra pain",
        "Pain is bad, but I can manage journeys over 2 hours",
        "Pain restricts me to journeys of less than 1 hour",
        "Pain restricts me to necessary journeys of under 30 minutes",
        "Pain prevents me from travelling except to the doctor"
      ]
    },
    {
      id: 'employment',
      label: '10) Employment / Home Making',
      options: [
        "My normal homemaking/work do not cause pain",
        "My normal homemaking/work increase my pain, but I can perform all required activities",
        "I can perform most homemaking/work, but pain prevents me from performing physically stressful activities",
        "Pain prevents me from doing anything but light duties",
        "Pain prevents me from doing even light duties",
        "Pain prevents me from doing any work/homemaking chores"
      ]
    }
  ], []);
  const renderOptions = (questionId, options) => (
    options.map((option, idx) => (
      <label key={idx} style={{ display: 'block' }}>
        <input
          type="radio"
          required
          name={questionId}
          value={idx}
          checked={formData[questionId] === String(idx)}
          onChange={() => handleChange(questionId, String(idx))}
        />
        {option}
      </label>
    ))
  );
  const styles = {
      backgroundColor: getRowClassName({sum}),
      padding: '20px',
      borderRadius: '8px',
      textAlign: 'center',
      color: 'white',
      width: '200px',
      margin: '20px auto',
  };
//   const styles2 = {
//     backgroundColor: getRowClassName({sum}),
//     padding: '20px',
//     borderRadius: '8px',
//     textAlign: 'center',
//     color: '#333',
//     width: '200px',
//     margin: '20px auto',
// };
  return (
    <div className="container assesform" >
      <div></div>
      {/* User infor */}
      <div >
      <div className="section1"
   id='pdf-content'
        >
          
        <div className="uservalues" > 
          <div >
          <p>Name: {sessionvalue.name}</p>
          <p>Mobile: {sessionvalue.mobile}</p>
          <p>Age: {sessionvalue.age}</p>
          </div>
         
          <div>
          <p>Gender: {sessionvalue.gender}</p>
          
          <p>Date: {sessionvalue.date}</p>
          <p>category: {sessionvalue.assesmentdata}</p>
          </div>   
          <hr/>
        </div>

     <div className='section2'  >
        <h3>Lower Back Pain Questionnaire</h3>

        <form onSubmit={handleSubmit} >
          {/* Map over the questions to render them dynamically */}
          {questions.map((question) => (
           <div key={question.id}>
              <p style={{fontWeight:800}}>{question.label}</p>
              {renderOptions(question.id, question.options)}
            </div>
          ))}
          
         {!flag?    <button type="submit" onClick={uploadpdf} >Submit</button>:null}
        </form>
        </div>
     
 {/* section2 */}
        <div>
        </div>
       {flag? <>
 
      <Modal title="assesment" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
      <h1 style={styles}>Score: {sum}%</h1>
  
     

<Table 
// style={styles} 
dataSource={dataSource} columns={columns} onClick={downloadPDF} />
      <Button type="primary"  onClick={downloadPDF}>
        Download as PDF
      </Button>
      </Modal>

        </>:null}
      </div>
     
      </div>
      <div></div>
    </div>
  );
};

export default Assesment;
